import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-6" }
const _hoisted_2 = { class: "d-flex justify-center pt-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[7] || (_cache[7] = _createElementVNode("h2", null, "Diary Alert Settings", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_alert, {
        color: "primary",
        type: "info",
        variant: "outlined",
        density: "compact"
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" Select classes to display an alert when there are missing entries during approval. ", -1)
        ]))]),
        _: 1
      })
    ]),
    _createVNode(_component_v_container, { class: "pt-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createElementVNode("h4", null, "Class Diary", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "6",
              "align-self": "center"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createElementVNode("h5", null, "Class", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "6",
              "align-self": "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: _ctx.input.classDiaryConfirmation.targetClassIds,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input.classDiaryConfirmation.targetClassIds) = $event)),
                  "item-title": "className",
                  "item-value": "classId",
                  items: _ctx.classes,
                  chips: "",
                  multiple: "",
                  variant: "outlined",
                  density: "compact",
                  "hide-details": "",
                  readonly: _ctx.isLoading
                }, null, 8, ["modelValue", "items", "readonly"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_container, { class: "pt-8" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createElementVNode("h4", null, "School Diary", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "6",
              "align-self": "center"
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createElementVNode("h5", null, "Class", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "6",
              "align-self": "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: _ctx.input.schoolDiaryConfirmation.targetClassIds,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.input.schoolDiaryConfirmation.targetClassIds) = $event)),
                  "item-title": "className",
                  "item-value": "classId",
                  items: _ctx.classes,
                  chips: "",
                  multiple: "",
                  variant: "outlined",
                  density: "compact",
                  "hide-details": "",
                  readonly: _ctx.isLoading
                }, null, 8, ["modelValue", "items", "readonly"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_btn, {
        onClick: _ctx.updateDiarySetting,
        loading: _ctx.isLoading,
        color: "primary",
        variant: "flat",
        large: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ])
  ]))
}